<template>
  <div class="container-page">
    <p class="title-inner">Новости и анализ СМИ</p>
    <div class="mb-16">
      <ButtonComponent mod="gradient-bg" buttonType="button" @click="editCard(0)" v-if="canCreateCurrent">
        Создать
      </ButtonComponent>
      <ButtonComponent
        mod="gradient-bg"
        buttonType="button"
        class="btn-small btn-export"
        @click="exportWord(tabIndex)"
        v-if="tabIndex < 3"
      >
        Экспорт
      </ButtonComponent>
    </div>
    <DefaultFilter :filterValue="currentFilter" @loadFilter="onLoadFilter" v-if="tabIndex < 3" />
    <TabsListInner v-if="newsTypes.length" v-on:select="tabSelected">
      <TabsDetailInner
        v-for="(type, index) in newsTypes"
        :key="type.id"
        :name="type.name"
        :selected="tabIndex === index"
      >
        <div>
          <div class="table-container mb-16 js-table-arrow">
            <table class="stockTable">
              <thead>
                <tr>
                  <th>Номер публикации</th>
                  <th>Заголовок</th>
                  <th>Статус</th>
                  <th class="date-column" scope="col">Дата и время публикации</th>
                  <th>Анонс</th>
                  <th></th>
                  <th></th>
                </tr>
                <tr>
                  <th class="filter"></th>
                  <th class="filter">
                    <FilterInput
                      placeholder="Заголовок"
                      v-model="newsBag[index].filter.name"
                      v-on:valueChangedDebounced="changeFilter(index)"
                    />
                  </th>
                  <th class="filter">
                    <FilterInput
                      :select2Options="entityStatuses"
                      placeholder="Статус"
                      type="select2"
                      v-model="newsBag[index].filter.statusId"
                      :select2Settings="select2Settings"
                      v-on:valueChangedDebounced="changeFilter(index)"
                    />
                  </th>
                  <th class="filter">
                    <FilterInput
                      class="mb-6"
                      placeholder="от"
                      type="date"
                      v-model="newsBag[index].filter.publicationDateFrom"
                      v-on:valueChangedDebounced="changeFilter(index)"
                    />
                    <FilterInput
                      class="mb-6"
                      placeholder="до"
                      type="date"
                      v-model="newsBag[index].filter.publicationDateTo"
                      v-on:valueChangedDebounced="changeFilter(index)"
                    />
                  </th>
                  <th class="filter">
                    <FilterInput
                      placeholder="Анонс"
                      v-model="newsBag[index].filter.previewText"
                      v-on:valueChangedDebounced="changeFilter(index)"
                    />
                  </th>
                  <th class="filter"></th>
                  <th class="filter"></th>
                </tr>
              </thead>
              <tbody v-if="newsBag[index]?.page?.items?.length && !newsBag[index]?.isLoading">
                <tr v-for="item in newsBag[index].page.items" :key="item.id" @dblclick="editCard(item.id)">
                  <td>{{ item.id }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.entityStatus.title }}</td>
                  <td>{{ item.activeFrom ? $momentFormat(item.activeFrom, 'DD.MM.YYYY HH:mm') : '' }}</td>
                  <td>{{ item.previewText }}</td>
                  <td>
                    <IconComponent @click="editCard(item.id)" name="mode" />
                  </td>
                  <td>
                    <IconComponent @click="deleteCard(type.id, item.id)" name="delete" />
                  </td>
                </tr>
              </tbody>
              <tbody v-else-if="newsBag[index]?.isLoading">
                <tr>
                  <td class="text-center" colspan="4">Загрузка...</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td class="text-center" colspan="5">Нет данных.</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="newsBag[index].page.pagesTotal > 1">
            <Pagination
              :pageCount="newsBag[index].page.pagesTotal"
              :currentPage="newsBag[index].page.pageNumber"
              @change="onPageChange($event, false, index)"
              @more="onPageChange($event, true, index)"
            />
          </div>
        </div>
      </TabsDetailInner>
      <TabsDetailInner name="Анализ СМИ" v-if="canView[3]" :selected="tabIndex === 3">
        <MassMedia :nn="loadSmi" />
      </TabsDetailInner>
    </TabsListInner>
  </div>
</template>

<script>
  import DefaultFilter from '@/common/components/DefaultFilter.vue';
  import FilterInput from '@/common/components/FilterInput.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import TabsDetailInner from '@/common/components/TabsDetailInner.vue';
  import TabsListInner from '@/common/components/TabsListInner.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';
  import IconComponent from '@/common/ui/IconComponent.vue';
  import Utils from '@/common/utils';
  import { loadFilter, saveFilter } from '@/common/utils/filterManager';

  import NsiApi from '../../nsi/api/nsi';
  import Api from '../api/news';
  import MassMedia from '../components/MassMedia.vue';

  const PERMISSIONS = {
    view: Constants.Permissions.MassMediaAccess,
    create: Constants.Permissions.MassMediaCreate,
    edit: Constants.Permissions.MassMediaEdit,
  };

  export default {
    name: 'News',
    components: {
      IconComponent,
      ButtonComponent,
      TabsListInner,
      TabsDetailInner,
      FilterInput,
      MassMedia,
      DefaultFilter,
    },
    mixins: [security],
    data() {
      return {
        newsBag: [],
        newsTypes: [],
        entityStatuses: [{ id: 0, text: Constants.emptySelectOptionText, selected: true }],
        select2Settings: Constants.select2Settings,
        currentNewsType: null,
        defaultRequest: {
          pageNumber: 1,
          pageSize: 0,
          isActive: true,
        },
        tabIndex: this.$route.query && this.$route.query.tab * 1 > 0 ? this.$route.query.tab * 1 : 0,
        loadSmi: 0,
        canView: [true, true, true, false],
        canEdit: [true, true, true, false],
        canCreateMassMedia: false,
      };
    },
    watch: {
      newsTypes: function () {
        if (this.tabIndex !== 3) {
          this.currentNewsType = this.newsTypes[0];
          this.loadPage(0);
        }
      },
    },
    async created() {
      //console.log(this.$route.query.tab);
      const [massMediaAccess, massMediaEdit, massMediaCreate] = await Promise.all([
        this.checkPermission(PERMISSIONS.view)
          .then((response) => response?.data)
          .catch(() => false),
        this.checkPermission(PERMISSIONS.edit)
          .then((response) => response?.data)
          .catch(() => false),
        this.checkPermission(PERMISSIONS.create)
          .then((response) => response?.data)
          .catch(() => false),
      ]);

      this.canView[3] = massMediaAccess;
      this.canEdit[3] = massMediaEdit;
      this.canCreateMassMedia = massMediaCreate;

      if (!massMediaAccess && this.tabIndex === 3) {
        this.tabIndex = 0;
        this.$router.replace({ name: 'News', query: { tab: 0 } });
      }

      loadFilter(this.$options.name).then((response) => {
        let filters = response;
        this.newsBag = [];
        NsiApi.search('nsinewstype', this.defaultRequest)
          .then((response) => {
            this.newsTypes = response.data.items;
            this.newsTypes.forEach((type) => {
              this.newsBag.push({
                page: {},
                request: {
                  pageNumber: 1,
                  pageSize: Constants.pageSize,
                  typeId: type.id,
                },
                filter: {},
                isLoading: false,
              });
            });

            if (filters)
              for (let i = 0; i < this.newsBag.length; i++) if (filters[i]) this.newsBag[i].filter = filters[i];
          })
          .catch((error) => {
            console.error(error?.response?.data);
          });
        this.loadDictionaries();

        console.log(this.tabIndex);
        if (this.tabIndex === 3 && this.canView[3]) {
          setTimeout(() => {
            this.loadSmi++;
          }, 500);
        }
      });
    },
    methods: {
      loadPage(index, append) {
        this.newsBag[index].isLoading = true;
        const request = Object.assign(this.newsBag[index].filter, this.newsBag[index].request);
        Api.search(request)
          .then((response) => {
            if (!append) {
              this.newsBag[index].page = {};
              this.newsBag[index].page = response.data;
            } else if (response.data) {
              this.newsBag[index].page.pageNumber = response.data.pageNumber;
              this.newsBag[index].page.items = this.newsBag[index].page.items.concat(response.data.items);
            }
            this.newsBag[index].isLoading = false;
          })
          .catch((error) => {
            this.newsBag[index].isLoading = false;
            console.error(error?.response?.data);
          });
      },
      loadDictionaries() {
        Utils.loadSelectOptions('entityStatusList', this.entityStatuses, true);
      },
      editCard(id) {
        if (this.tabIndex == 3) {
          const canMutate = id > 0 ? this.canEdit[3] : this.canCreateMassMedia;
          this.$router.push({
            name: 'MassMediaCard',
            params: { id: id, action: canMutate ? 'edit' : 'view' },
          });
          return;
        }

        this.$router.push({ name: 'NewsCard', params: { typeId: this.currentNewsType.id, id: id, action: 'edit' } });
      },
      deleteCard(typeId, id) {
        Constants.alert.fire(Constants.confirmOptions.delete).then((res) => {
          if (res.isConfirmed) {
            Api.delete(typeId, id)
              .then((response) => {
                console.log(response);
                Constants.alert.fire('Удаление', 'Запись удалена', 'success');
                this.loadPage(this.tabIndex, false);
              })
              .catch((error) => {
                Constants.alert.fire(
                  'Удаление',
                  error.response && error.response.data ? error.response.data : 'Запись не удалена.',
                  'error',
                );
              });
          }
        });
      },
      onPageChange(pageNumber, addToExist, index) {
        this.newsBag[index].request.pageNumber = pageNumber;
        this.loadPage(index, addToExist);
      },
      tabSelected(index) {
        var isChange = this.tabIndex != index;
        if (isChange) {
          this.tabIndex = index;

          if (this.tabIndex < 3) {
            this.currentNewsType = this.newsTypes[index];
            this.loadPage(index);
          } else if (this.canView[3]) {
            this.loadSmi++;
          }
        }
      },
      changeFilter(index) {
        this.newsBag[index].request.pageNumber = 1;

        saveFilter(this.$options.name, this.currentFilter);

        this.loadPage(index, false);
      },
      exportWord(index) {
        Api.exportWord(this.newsBag[index]?.filter);
      },
      onLoadFilter(item) {
        if (item) for (let i = 0; i < this.newsBag.length; i++) if (item[i]) this.newsBag[i].filter = item[i];
        this.changeFilter(this.tabIndex);
      },
    },
    computed: {
      canCreateCurrent() {
        return this.tabIndex === 3 ? this.canCreateMassMedia : this.canEdit[this.tabIndex];
      },
      currentFilter() {
        let filters = [];
        for (let i = 0; i < this.newsBag.length; i++) filters.push(this.newsBag[i].filter);
        return filters;
      },
    },
  };
</script>

<style scoped>
  .btn-export {
    margin-left: 15px;
  }
</style>

<style lang="scss" scoped>
  .table-container.analysisTable table.stockTable thead th {
    width: 10%;
    &:nth-of-type(4),
    &:nth-of-type(5) {
      min-width: 390px;
    }
  }

  .date-column {
    min-width: 200px;
  }
</style>
